// SPDX-License-Identifier: Apache-2.0
export type CameraConfig = {
  heading: number;
  pitch: number;
  roll: number;
};

export default class GlobeState {
  public loaded = false;
  public shadows = false;
  public shadowsTimestamp = Date.now();
  public camera: CameraConfig | null = null;
}
